import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import fitpro from "../../assets/images/fitpro.png";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { loginapi } from "../../api/login";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const showToast = (message, success) => {
    if (success) {
      toast.success(message);
    } else {
      toast.error(message);
    }
  };

  const getCookie = (name) => {
    const cookieStr = document.cookie;
    const cookies = cookieStr.split('; ');

    for (let cookie of cookies) {
      const [key, value] = cookie.split('=');
      if (key === name) return decodeURIComponent(value);
    }

    return null;
  };

  useEffect(() => {
    const login = getCookie("accessToken")
    // const login = localStorage.getItem("isAuthenticated");
    if(login){
      navigate("/dashboard");
    }
  },[navigate])



  const handleSubmit = async(e) => {
    e.preventDefault();

    try{
      const resp= await loginapi({
        "email": email,
        "password": password
      })


      const expiryDate = new Date(resp?.expiresAt).toUTCString();
      document.cookie = `accessToken=${resp?.accessToken}; expires=${expiryDate}; path=/; secure; SameSite=Strict`;
      showToast("Logged in successfully!", true);




      setTimeout(() => {
        navigate("/dashboard");
      }, 2000);
      console.log("resp",resp)
      // if (email === "fitpro@gmail.com" && password === "lhvNRFhcLDfoO45") {
      //   const authStatus = btoa("true");
      //   localStorage.setItem("isAuthenticated", authStatus);

      //   showToast("Logged in successfully!", true);

      //   setTimeout(() => {
      //     navigate("/dashboard");
      //   }, 2000);
      // } else {
      //   showToast("Incorrect email or password.", false);
      // }
    }catch (e){
      showToast(e?.message, false);
    }



  };

  return (
    <div className="container d-flex justify-content-center align-items-center vh-100 bg-light">
      <div
        className="card shadow-sm"
        style={{ width: "100%", maxWidth: "400px", borderRadius: "15px" }}
      >
        <div className="card-body p-5">
          <img
            src={fitpro}
            alt="Logo"
            className="mb-4"
            style={{ width: "120px", display: "block", margin: "0 auto" }}
          />
          <h3 className="card-title text-center mb-4">Login to Your Account</h3>
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label htmlFor="email" className="form-label">
                Email address
              </label>
              <input
                type="email"
                className="form-control"
                id="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="mb-4">
              <label htmlFor="password" className="form-label">
                Password
              </label>
              <input
                type="password"
                className="form-control"
                id="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <button
              type="submit"
              className="btn btn-primary w-100 rounded-pill"
              style={{ backgroundColor: "#1E70C8", borderColor: "#1E70C8" }}
            >
              Login
            </button>
          </form>
          <div className="text-center mt-3">
            <p className="text-muted">
              If you have another account, please use it to log in.
            </p>
          </div>
        </div>
      </div>

    </div>
  );
};

export default Login;
